/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `0` - off
 * * `1` - standard
 * @export
 */
export const UsePreconditionerCgEnum = {
  OFF: 0,
  STANDARD: 1,
} as const;
export type UsePreconditionerCgEnum =
  (typeof UsePreconditionerCgEnum)[keyof typeof UsePreconditionerCgEnum];

export function instanceOfUsePreconditionerCgEnum(value: any): boolean {
  for (const key in UsePreconditionerCgEnum) {
    if (Object.prototype.hasOwnProperty.call(UsePreconditionerCgEnum, key)) {
      if (UsePreconditionerCgEnum[key as keyof typeof UsePreconditionerCgEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function UsePreconditionerCgEnumFromJSON(json: any): UsePreconditionerCgEnum {
  return UsePreconditionerCgEnumFromJSONTyped(json, false);
}

export function UsePreconditionerCgEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UsePreconditionerCgEnum {
  return json as UsePreconditionerCgEnum;
}

export function UsePreconditionerCgEnumToJSON(value?: UsePreconditionerCgEnum | null): any {
  return value as any;
}

export function UsePreconditionerCgEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): UsePreconditionerCgEnum {
  return value as UsePreconditionerCgEnum;
}
